import { createFileRoute } from '@tanstack/react-router'
import { RiderAppGate } from '@/components/rider/RiderAppGate'
import { DispatchPage } from '@/components/dispatch/DispatchPage'

function DispatchRoutePage() {
  return (
    <RiderAppGate>
      <DispatchPage />
    </RiderAppGate>
  )
}

export const Route = createFileRoute('/admin/dispatch')({
  component: DispatchRoutePage,
})
